<div class="wrapper mb-2">
    <div class="row">
        <div class="col-md-5 col-sm-12 text-left">
            <img src="./assets/icons/arrow.svg">
            <span class="label-title ml-2 mr-3">Nova Recarga</span>
        </div>
        <div class="col-md-7 col-sm-12 p-0">
            <div class="row container-fluid menu-navegacao-borda m-0 bg-white">
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">PRODUTOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto select">FAVORECIDOS</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CRÉDITO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">CONFIRMAÇÃO</span>
                    <span class="menu-navegacao-seta"></span>
                </div>
                <div class="menu-navegacao-espacamento d-flex align-items-center">
                    <span class="menu-navegacao-icone"></span>
                    <span class="menu-navegacao-texto">PAGAMENTO</span>
                </div>
            </div>
        </div>

        <div class="component-box container-fluid p-5">
            <div class="row logo-container">
                <span class="component-title">Selecione um grupo</span>
            </div>
            <div class="row title-container align-items-center mt-3 mb-4">
                <input [(ngModel)]="search" type="text" placeholder="Busca">
                <button (click)="filtrar()" class="action-button ml-2">Filtrar</button>
                <button (click)="limparFiltros()" class="action-button white-button ml-2">Limpar filtros</button>
            </div>
            <div class="row cards">
                <div   *ngFor="let item of groups" class="w-30" type="radio">
                    <div  [ngClass]="item.selecionado ? 'card-active' : 'card-inactive'" (click)="activate(item)" class="row benefit-card" ><!-- *ngIf="item.produtoElegibilidade.produto.produtoId !== 9" -->

                            <div [ngClass]="item.selecionado ? 'checkbox-active' : 'checkbox-inactive'" class="custom-checkbox mb-1"></div>
                            <div [ngClass]="item.selecionado ? 'pic-active' : 'pic-inactive'" class="span-container">
                                {{ item.name.charAt(0) }}
                            </div>
                            <div class="column">
                                <span [ngClass]="item.selecionado ? 'label-active' : 'label-inactive'" class="label-beneficio">{{ item.name }}</span>
                                <br>
                                <span [ngClass]="item.selecionado ? 'label-active' : 'label-inactive'" class="label-number">{{ item.countCollaborators }} favorecidos</span>
                            </div>
                    </div>
                </div>
            </div>
            <div class="row buttons mb-3 mt-3">
                <!--<button (click)="savePedido()" class="action-button white-button ml-2 mr-2">Salvar</button>-->
                <button class="custom-button-back" (click)='previous()'>Voltar</button>
                <button class="custom-button-full" (click)='next()'>Continuar</button>
            </div>
        </div>
    </div>
</div>
